import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configCenterApi } from '../api/configCenterApi';
import type { ConfigEntryRequest } from '../types/configCenter';

/**
 * POST /api/eraf/config-center — 설정 생성 (CONFIG_CENTER_WRITE)
 * 성공 시 list + categories + changes queryKey invalidate
 */
export function useCreateConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: ConfigEntryRequest) => configCenterApi.create(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['config-center', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['config-center', 'categories'] });
      void queryClient.invalidateQueries({ queryKey: ['config-center', 'changes'] });
    },
  });
}

/**
 * PUT /api/eraf/config-center/{key} — 설정 수정 (CONFIG_CENTER_WRITE)
 */
export function useUpdateConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ key, body }: { key: string; body: ConfigEntryRequest }) =>
      configCenterApi.update(key, body),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ['config-center', 'list'] });
      void queryClient.invalidateQueries({
        queryKey: ['config-center', 'entry', variables.key],
      });
      void queryClient.invalidateQueries({ queryKey: ['config-center', 'changes'] });
    },
  });
}
